import { GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import FileIcon from '../../vue_shared/components/file_icon.vue?vue3';
import axios from '../../lib/utils/axios_utils.js?vue3';
import { logError } from '~/lib/logger';
import { contentTypeMultipartFormData } from '~/lib/utils/headers';
import { bytesToMiB, numberToHumanSize } from '~/lib/utils/number_utils';
import { visitUrl, joinPaths } from '~/lib/utils/url_utility';
import { __, sprintf } from '~/locale';
import UploadDropzone from '../../vue_shared/components/upload_dropzone/upload_dropzone.vue?vue3';
import CommitChangesModal from './commit_changes_modal.vue?vue3';
import { InternalEvents } from '../../tracking/index.js?vue3';
export default {
    name: 'UploadBlobModal',
    components: {
        GlButton,
        UploadDropzone,
        FileIcon,
        CommitChangesModal
    },
    i18n: {
        REMOVE_FILE_TEXT: __('Remove file'),
        ERROR_MESSAGE: __('Error uploading file. Please try again.'),
        DIRECTORY_FILE_ERROR: __('Directories cannot be uploaded. Please upload a single file instead.'),
        FILE_TOO_BIG_ERROR: __('File is too big (%{fileSize}MiB). Max filesize: %{maxFileSize}MiB.')
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        modalId: {
            type: String,
            required: true
        },
        commitMessage: {
            type: String,
            required: true
        },
        targetBranch: {
            type: String,
            required: true
        },
        originalBranch: {
            type: String,
            required: true
        },
        canPushCode: {
            type: Boolean,
            required: true
        },
        canPushToBranch: {
            type: Boolean,
            required: true
        },
        path: {
            type: String,
            required: true
        },
        replacePath: {
            type: String,
            default: null,
            required: false
        },
        emptyRepo: {
            type: Boolean,
            required: false,
            default: false
        },
        uploadPath: {
            type: String,
            default: null,
            required: false
        }
    },
    data () {
        return {
            file: null,
            filePreviewURL: null,
            loading: false,
            hasDirectoryUploadError: false,
            error: null
        };
    },
    computed: {
        formattedFileSize () {
            return numberToHumanSize(this.file.size);
        },
        isValid () {
            return Boolean(this.file);
        }
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties -- invoked externally via this.$refs[...].show() in blob_button_group.vue
        show () {
            this.$refs[this.modalId].show();
        },
        setFile (file) {
            this.error = null;
            const fileSizeMiB = bytesToMiB(file.size);
            const maxFileSizeMiB = gon.max_file_size;
            if (maxFileSizeMiB && fileSizeMiB > maxFileSizeMiB) {
                this.removeFile();
                this.error = sprintf(this.$options.i18n.FILE_TOO_BIG_ERROR, {
                    fileSize: fileSizeMiB.toFixed(2),
                    maxFileSize: maxFileSizeMiB
                });
                return;
            }
            this.file = file;
            const fileUurlReader = new FileReader();
            fileUurlReader.readAsDataURL(this.file);
            fileUurlReader.onload = (e)=>{
                this.filePreviewURL = e.target?.result;
                this.hasDirectoryUploadError = false;
                this.trackEvent('file_upload_placement_successful_in_upload_blob_modal');
            };
            fileUurlReader.onerror = (e)=>{
                const error = e.target?.error;
                // eslint-disable-next-line no-extra-boolean-cast
                if (!Boolean(this.file?.type)) {
                    this.file = null;
                    this.hasDirectoryUploadError = true;
                }
                logError(`Failed to ${this.replacePath ? 'replace' : 'upload'} file. See exception details for more information.`, error);
            };
        },
        removeFile () {
            this.file = null;
            this.filePreviewURL = null;
        },
        submitForm (formData) {
            this.error = null;
            return this.replacePath ? this.replaceFile(formData) : this.uploadFile(formData);
        },
        submitRequest (method, url, formData) {
            this.loading = true;
            formData.append('file', this.file);
            return axios({
                method,
                url,
                data: formData,
                headers: {
                    ...contentTypeMultipartFormData
                }
            }).then((response)=>{
                this.trackEvent('file_upload_successful_in_upload_blob_modal');
                visitUrl(response.data.filePath);
            }).catch((e)=>{
                logError(`Failed to ${this.replacePath ? 'replace' : 'upload'} file. See exception details for more information.`, e);
                this.error = e.response?.data?.message || e.response?.data?.error || this.$options.i18n.ERROR_MESSAGE;
            }).finally(()=>{
                this.loading = false;
            });
        },
        replaceFile (formData) {
            // The PUT path can be generated from $route (similar to "uploadFile") once router is connected
            // Follow-up issue: https://gitlab.com/gitlab-org/gitlab/-/issues/332736
            return this.submitRequest('put', this.replacePath, formData);
        },
        uploadFile (formData) {
            const calculatedPath = this.uploadPath || joinPaths(this.path, this.$route.params.path);
            return this.submitRequest('post', calculatedPath, formData);
        },
        handleModalClose () {
            this.error = null;
            this.hasDirectoryUploadError = false;
        }
    },
    validFileMimetypes: []
};
